import events from "_src/engine/events";
import output from "_src/engine/output";

import { stepType } from "_src/constants";
import eraser from "_src/manipulators/libs/eraser";
import selector from "_src/manipulators/libs/selector";
import workspace from "_src/workspace";
import Selector from "_src/client/manipulators/selector";
import history from "_src/history/manager";
import config from "_src/config";
import appState from "_src/app_state";
import gizmo from "_src/client/controls/gizmo";
import {vec3} from "_src/libs/gl-matrix";
import {geometry} from "_src/engine/constants";
import projectTree from "_src/reformer/project_tree";

export default class Eraser extends Selector {

  constructor(camera) {
    super(camera);
  }

  async erase() {

    await this._selectionPromise;
    const erasedObjects = this._removeSelectedGeometry();

    if (erasedObjects.length !== 0) {
      history.addStep(stepType.ERASE);
      events.emit("objects_updated", erasedObjects);

      if (appState.getStateValue("selectionType") === appState.ST_CUT_OFF_PLANE) {
        const point = gizmo.getPosition();
        const normal = vec3.clone(geometry.AXIS_Z);
        vec3.transformQuat(normal, normal, gizmo.getRotation());
        history.writeSelectionPlaneToCurrentStep(this, point, normal);
      }

      const objects = [];
      for (const object of erasedObjects) {
        objects.push({id: object.id});
        projectTree.syncPrimitivesCount(object);
      }

      // NOTE: Currently we drop selection on all objects to avoid complex selection steps processing
      for (const object of workspace.getObjects()) {
        let changed = false;
        for (const frame of object.frames) {
          const updatedChunks = [];
          for (const chunk of frame.model.chunks) {
            if (chunk.geometry.checkHasSelectedVertices()) {
              updatedChunks.push(chunk.getID());
            }
          }
          if (updatedChunks.length > 0) {
            history.writeFrameToCurrentStep({type: stepType.SELECT, frame: frame, chunksUp: updatedChunks});
            changed = true;
          }
        }
        if (changed) {
          selector.dropSelection(object);
        }
      }

      const steps = history.getLastConsecutiveSelectionSteps();
      events.emit("erase", {objects, steps});

    } else if (config.enableManipulatorsWarnings) {
      output.warn("Nothing erased:\n" + workspace.getVerbosityInfo());
    }

  }

  _removeSelectedGeometry() {

    const objects = workspace.getObjects().filter((object) => {return this._checkCanSelect(object)});

    const erasedObjects = [];

    for (let object of objects) {

      this._pushGeometryToHistory(object);

      if (eraser.removeSelectedVertices(object)) {

        erasedObjects.push(object);

      }

    }

    return erasedObjects;

  }

  _pushGeometryToHistory(object) {

    for (let frame of object.frames) {

      const selectedChunksIDs = [];

      for (let chunk of frame.model.chunks) {

        const geometry = chunk.geometry;

        if (geometry.checkHasSelectedVertices()) {
          selectedChunksIDs.push(chunk.getID());
        }

      }

      if (selectedChunksIDs.length > 0) {
        history.writeFrameToCurrentStep({type: stepType.ERASE, frame: frame, chunksUp: selectedChunksIDs});
      }

    }

  }

}
